import TravelUIPcFooter from '@travel-ui/pc-footer';
import {
  BusinessDetails,
  LoginOutButton,
  MiddleSectionButton,
  NavItem,
  NavRow,
  ScrollTopButton,
} from '@travel-ui/pc-footer/core';
import { disclaimer } from './MyMoFooter';

const PcFooter = () => {
  return (
    <TravelUIPcFooter
      className={'travelFooter'}
      topSectionButtons={
        <>
          <ScrollTopButton />
        </>
      }
      middleSectionButtons={
        <>
          <LoginOutButton />
          <MiddleSectionButton href="https://m.naver.com/services.html">전체서비스</MiddleSectionButton>
        </>
      }
      businessDetails={<BusinessDetails />}
      navigations={
        <>
          <NavRow>
            <NavItem url="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=2208162517">사업자정보 공개</NavItem>
            <NavItem url="https://policy.naver.com/policy/service.html">이용약관</NavItem>
          </NavRow>
          <NavRow>
            <NavItem url="https://policy.naver.com/policy/privacy.html">
              <strong>개인정보처리방침</strong>
            </NavItem>
            <NavItem url="https://help.naver.com/alias/contents2/navertravel/travel.naver">고객센터</NavItem>
          </NavRow>
        </>
      }
      disclaimer={disclaimer}
    />
  );
};

export default PcFooter;
